<template>
  <div class="sc-benefits">
    <div class="container">
      <div class="sc-benefits-header">
        <h2 class="sc-title -center -small-margin">
          Využi svoj potenciál a pridaj sa k nášmu tímu
        </h2>
        <p class="sc-lead -center -margin-bottom">
          Každý jednotlivec v tíme je dôležitý, pretože len spoločne môžeme dosiahnuť tie najlepšie výsledky. Staneš sa jedným z nás?
        </p>
      </div>
      <div class="row">
        <div
          v-for="(item, i) in benefitsActive"
          :key="i"
          class="column -xs6 -md3"
        >
          <BenefitItem
            :title="item.title"
            :text="item.text"
            :icon="item.icon"
          />
        </div>
      </div>
      <div class="sc-benefits-footer">
        <UButton
          v-if="!benefitsShowAll"
          @click="benefitsShowAll = true"
          size="large"
        >
          {{ showMoreText }}
        </UButton>
      </div>
    </div>
  </div>
</template>

<script>
import benefits from '@/data/benefitsSales';

import BenefitItem from '@/components/SCBenefitItem.vue';
import UButton from '@/components/UButton.vue';

export default {
  components: {
    BenefitItem,
    UButton,
  },
  data() {
    return {
      benefits,
      benefitsShowAll: false,
    };
  },
  computed: {
    benefitsActive() {
      return this.benefitsShowAll ? this.benefits : this.benefits.slice(0, 4);
    },
    showMoreText() {
      const count = this.benefits.length - 4;
      if (count === 1) {
        return 'Zobraziť ďalší benefit';
      }
      if (count < 5) {
        return `Zobraziť ďalšie ${count} benefity`;
      }
      return `Zobraziť ďalších ${count} benefitov`;
    },
  },
};
</script>

<style lang="scss" scoped>
.sc-benefits {
  padding: 50px 0;
  @media screen and (min-width: $screen-md) {
    padding: 120px 0;
  }
  .sc-benefits-header {
    margin-bottom: 50px;
    @media screen and (min-width: $screen-md) {
      margin-bottom: 100px;
    }
  }
  .sc-benefits-footer {
    text-align: center;
  }
}
</style>
